import { onMounted, onUnmounted } from '@vue/composition-api';
import { yoda } from '@/utils/yoda';

function useResume(listener: Function) {
    onMounted(async () => {
        try {
            await yoda.ready();
            // 监听webview到栈顶
            yoda.event?.addEventListener('resume', listener);
        } catch {
            //
        }
    });

    onUnmounted(() => {
        yoda.event?.removeEventListener('resume', listener);
    });
}

export default useResume;

// 仅安卓 待测试
export const useHalfResume = (listener: Function) => {
    onMounted(async () => {
        try {
            await yoda.ready();
            // 监听webview到栈顶
            yoda.event?.addEventListener('half_web_resume', listener);
        } catch {
            //
        }
    });

    onUnmounted(() => {
        yoda.event?.removeEventListener('half_web_resume', listener);
    });
};

export const useResumeV2 = (cb: Function) => {
    document.addEventListener('visibilitychange', () => {
        const visible = document.visibilityState;
        if (visible === 'visible') cb();
    });
};

export const useLeaveV2 = (cb: Function) => {
    document.addEventListener('visibilitychange', () => {
        const visible = document.visibilityState;
        if (visible === 'hidden') cb();
    });
};
